import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Loader2, CalendarCheck, RefreshCw, XCircle } from 'lucide-react';
import { format, parseISO } from 'date-fns';

export const ExistingReservationBanner = ({ reservation, onChange, onCancel }) => {
  const [busy, setBusy] = useState(null);

  const run = async (action, fn) => {
    setBusy(action);
    try { await fn(); } finally { setBusy(null); }
  };

  const dateLabel = format(parseISO(reservation.reservation_date.slice(0, 10)), 'EEE, MMM d, yyyy');

  return (
    <Card className="border-2 border-[#9F1239] bg-[#FEF2F2] shadow-sm" data-testid="existing-reservation-banner">
      <CardContent className="p-5 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex items-start gap-3">
          <CalendarCheck className="w-6 h-6 text-[#9F1239] mt-1 flex-shrink-0" />
          <div>
            <p className="font-serif text-lg text-[#1C1917]">You already have a reservation for this date</p>
            <p className="text-sm text-[#78716C]" data-testid="existing-reservation-details">
              Seat <span className="font-semibold text-[#1C1917]" data-testid="existing-reservation-seat">{reservation.inventory_label}</span>
              {' · '}{dateLabel}
              {reservation.room_number && <> · {reservation.guest_type === 'resident' ? 'Unit' : 'Room'} <span data-testid="existing-reservation-room">{reservation.room_number}</span></>}
              {' · '}Code <span className="font-semibold text-[#9F1239]" data-testid="existing-reservation-code">{reservation.confirmation_code}</span>
            </p>
            <p className="text-xs text-[#A8A29E] mt-1">Only one seat per guest per day. Change or cancel it to book a different seat.</p>
          </div>
        </div>
        <div className="flex gap-2 flex-shrink-0">
          <Button
            variant="outline"
            disabled={!!busy}
            onClick={() => run('change', onChange)}
            className="border-[#9F1239] text-[#9F1239] hover:bg-white"
            data-testid="btn-change-existing-reservation"
          >
            {busy === 'change' ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <RefreshCw className="w-4 h-4 mr-2" />}
            Change
          </Button>
          <Button
            variant="destructive"
            disabled={!!busy}
            onClick={() => run('cancel', onCancel)}
            data-testid="btn-cancel-existing-reservation"
          >
            {busy === 'cancel' ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <XCircle className="w-4 h-4 mr-2" />}
            Cancel
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
